import { CatalogProductType } from '../enums'
import i18next from 'i18next'
import CatalogProduct, {
  AuroraCatalogProduct,
  AxiomaW1CatalogProduct,
  ElectricalCabinetCatalogProduct,
  GeneratorCatalogProduct,
  HeaterCatalogProduct,
  RuuviTagCatalogProduct,
  SpineLoadCatalogProduct,
  SpineModuleCatalogProduct,
  SpineMultimeasurementCatalogProduct,
  ValveCatalogProduct
} from '../types/CatalogProduct'

export const translateCatalogProductType = (type: CatalogProductType) => {
  switch (type) {
    case CatalogProductType.ELECTRICAL_CABINET:
      return i18next.t('electricalCabinet', { ns: 'catalogProduct' })
    case CatalogProductType.SPINE_MODULE:
      return i18next.t('spineModule', { ns: 'catalogProduct' })
    case CatalogProductType.GENERATOR:
      return i18next.t('generator', { ns: 'catalogProduct' })
    case CatalogProductType.HEATER:
      return i18next.t('heater', { ns: 'catalogProduct' })
    case CatalogProductType.AURORA:
      return i18next.t('aurora', { ns: 'catalogProduct' })
    case CatalogProductType.SPINE_LOAD:
      return i18next.t('spineLoad', { ns: 'catalogProduct' })
    case CatalogProductType.VALVE:
      return i18next.t('valve', { ns: 'catalogProduct' })
  }
}

export function isSpineMultiMeasurementCatalogProduct(
  product: CatalogProduct
): product is SpineMultimeasurementCatalogProduct {
  return product.type === CatalogProductType.SPINE_MULTI_MEASUREMENT
}

export function isValveCatalogProduct(product: CatalogProduct): product is ValveCatalogProduct {
  return product.type === CatalogProductType.VALVE
}

export function isElectricalCabinetCatalogProduct(
  product: CatalogProduct
): product is ElectricalCabinetCatalogProduct {
  return product.type === CatalogProductType.ELECTRICAL_CABINET
}

export function isSpineModuleCatalogProduct(
  product: CatalogProduct
): product is SpineModuleCatalogProduct {
  return product.type === CatalogProductType.SPINE_MODULE
}

export function isSpineLoadCatalogProduct(
  product: CatalogProduct
): product is SpineLoadCatalogProduct {
  return product.type === CatalogProductType.SPINE_LOAD
}

/**
 * Electrical cabinets and spine modules share the same custom data.
 */
export function isElectricalCabinetOrSpineModuleCatalogProduct(
  product: CatalogProduct
): product is ElectricalCabinetCatalogProduct | SpineModuleCatalogProduct {
  return isElectricalCabinetCatalogProduct(product) || isSpineModuleCatalogProduct(product)
}

export function isRuuviTagCatalogProduct(
  product: CatalogProduct
): product is RuuviTagCatalogProduct {
  return product.type === CatalogProductType.RUUVI_TAG
}

export function isAuroraCatalogProduct(product: CatalogProduct): product is AuroraCatalogProduct {
  return product.type === CatalogProductType.AURORA
}

export function isGeneratorCatalogProduct(
  product: CatalogProduct
): product is GeneratorCatalogProduct {
  return product.type === CatalogProductType.GENERATOR
}

export function isHeaterCatalogProduct(product: CatalogProduct): product is HeaterCatalogProduct {
  return product.type === CatalogProductType.HEATER
}

export function isAxiomaW1CatalogProduct(
  product: CatalogProduct
): product is AxiomaW1CatalogProduct {
  return product.type === CatalogProductType.AXIOMA_W1
}
